module.exports = __webpack_public_path__ + "img/robot_yaobu.asm.1056bfb8.jpg";